import {Component, Input} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {faSort, faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import {Observable, of} from "rxjs";
import {CatalogApiService} from "src/app/api/catalog-api.service";
import {AccessoryItem, ArticleType} from "src/app/model/order/order";
import {SortOrder} from "src/app/model/pagination/sort";
import {CartService} from "src/app/utils/cart/cart.service";
import {CareAndAccessoriesService} from "../care-and-accessories.service";
import {TranslateService} from "@ngx-translate/core";
import {OrderItem} from "../../model/order/order";

@Component({
  selector: 'app-accessories',
  templateUrl: './accessories.component.html',
  styleUrls: ['./accessories.component.scss']
})
export class AccessoriesComponent {

  @Input() ordering = true;

  originalAccessoryItems: AccessoryItem[];
  filteredAccessoryItems: Observable<AccessoryItem[]>;

  form: FormGroup;

  order: SortOrder = SortOrder.ASC;

  constructor(private careAndAccessoriesService: CareAndAccessoriesService,
              private formBuilder: FormBuilder,
              private cartService: CartService,
              private catalogApiService: CatalogApiService,
              private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      searchAccessoryInput: []
    });

    this.catalogApiService.getAccessories().subscribe(data => {
      this.originalAccessoryItems = data;
      this.originalAccessoryItems.forEach(item => {
        item.units = 1;
      });
      this.filterAccessory();
    });

    this.form.get('searchAccessoryInput').valueChanges.subscribe(() => this.filterAccessory());
  }

  sortByName(intermediateArray?: AccessoryItem[]): AccessoryItem[] {
    if (intermediateArray) {
      const i = intermediateArray.sort((firstItem, secondItem) => {
        if (firstItem.name < secondItem.name) {
          if (this.order === SortOrder.ASC) {
            return -1;
          } else {
            return 1;
          }
        }
        if (firstItem.name > secondItem.name) {
          if (this.order === SortOrder.ASC) {
            return 1;
          } else {
            return -1;
          }
        }
        return 0;
      });
      return i;
    } else {
      this.order = (this.order === SortOrder.ASC) ? SortOrder.DESC : SortOrder.ASC;
      this.filterAccessory();
    }
  }

  public addAccessoryItem(item: AccessoryItem, quantity: number) {
    if (quantity < 1) {
      quantity = 1;
    }
    if (quantity > 999) {
      quantity = 999;
    }
    this.cartService.addCartCareAccessoriesItem(this.careAndAccessoriesService.convertCareAccessoriesToOrderItem(item, ArticleType.ACCESSORY, +quantity));
  }

  private filterAccessory() {
    const filterValue = (this.form.get('searchAccessoryInput').value) ? this.normalizeValue(this.form.get('searchAccessoryInput').value) : '';
    this.filteredAccessoryItems = of(this.sortByName(this.originalAccessoryItems.filter(accessoryItem => this.normalizeValue(accessoryItem.name).includes(filterValue))));
  }

  private normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  clearSearchAccessoryInput() {
    this.form.get('searchAccessoryInput').setValue('');
  }


  getSortIcon() {
    if (!this.order) {
      return faSort;
    } else if (this.order === SortOrder.ASC) {
      return faSortDown;
    } else if (this.order === SortOrder.DESC) {
      return faSortUp;
    } else {
      throw Error("Unexpected sort order: " + this.order);
    }
  }

  getDiscountHint(priceInfo: string): string[] {
    return priceInfo.split("; ");
  }

  getExclamationHint(): string {
    let hint: string = "";
    this.translateService.get("newOrder.equipment.electronicOrdering").subscribe(data => hint = data);
    return hint;
  }

  switchOrdering(item: OrderItem, id: number) {
    let request = this.catalogApiService.switchOrdering(id);
    request.subscribe((response) => {
      if (response.success) {
        item.electronicOrdering = !item.electronicOrdering;
        console.log("Successfully switched electronic ordering for article: " + id);
      } else {
        console.log("Failed to switch electronic ordering");
        console.log(response.httpError);
      }
    });
  }
}
